import { __decorate } from "tslib";
import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator';
import { deleteTask, zoneList } from '@blade-sxp/task-management/api/off-duty-detection/index';
import authItem from '@blade/common/components/auth/auth-item.vue';
import tableHeader from '@blade-sxp/task-management/components/table-header.vue';
import errDialog from '@blade-sxp/task-management/pages/create-task/components/err-dialog.vue';
import { queryDeviceTaskErrorConfigs, updateTaskStatus } from '@blade-sxp/task-management/api/creat-task/index';
import AuthNewitem from '@blade/common/components/auth/auth-newItem.vue';
import { permissionlevel } from '@blade/common/constants/role-mode';
import colors from '@/styles/color.scss';
import taskType from '@blade-sxp/task-management/lang/task-type';
import { TaskStatusType } from '@blade-sxp/task-management/interfaces/createInterfaces';
let default_1 = class default_1 extends Vue {
    multipleTable;
    data;
    code;
    loading;
    pagination;
    refresh;
    goPage;
    changeParam;
    type;
    colors = colors;
    permissionlevel = permissionlevel;
    failDialogVisible = false;
    gridData = [];
    errImg = require('@blade-sxp/task-management/assets/subtract.png');
    union = require('@blade-sxp/task-management/assets/union.png');
    taskStatus = '';
    popoverStatus;
    filterZone = [];
    filterTaskStatus = [];
    popoverStatuss = true;
    enable = TaskStatusType.ENABLE; // 任务关闭
    disable = TaskStatusType.DISABLE; // 任务开启
    tableMaxHeight = 700;
    changeLoading(loading) {
        if (loading === false && this.popoverStatus) {
            this.$refs.popover.showPopper = false;
            this.popoverStatus = false;
        }
    }
    ellipsisName(str) {
        return str?.length > 15 ? str.slice(0, 15) + '...' : str;
    }
    initI18n() {
        this.filterZone = [];
        this.filterTaskStatus = [
            { text: String(this.$t('effect')), value: 'ENABLE' },
            { text: String(this.$t('noEffective')), value: 'DISABLE' },
            { text: String(this.$t('abnormal')), value: 'ERROR' },
        ];
    }
    getTaskStatusType(type) {
        return type === TaskStatusType.ERROR ? TaskStatusType.ENABLE : type;
    }
    filterZoneTag(value, row) {
        return row.zoneId === value;
    }
    filterTaskStatusTag(value, row) {
        return row.status === value;
    }
    handleSizeChange(val) {
        this.changeParam('size', val);
    }
    handleCurrentChange(val) {
        this.changeParam('current', val);
    }
    getZoneList() {
        let param = {
            externalBizFrom: '',
            keywords: '',
        };
        zoneList(param).then((res) => {
            if (res.constructor === Array) {
                for (let i in res) {
                    if (res[i].children.length !== 0) {
                        let obj = {
                            text: '',
                            value: 0,
                        };
                        obj.text = res[i].name;
                        obj.value = res[i].id;
                        this.filterZone.push(obj);
                        for (let j in res[i].children) {
                            let objChildren = {
                                text: '',
                                value: 0,
                            };
                            objChildren.text = res[i].children[j].name;
                            objChildren.value = res[i].children[j].id;
                            this.filterZone.push(objChildren);
                        }
                    }
                }
            }
            else if (res.constructor === Object) {
                if (res.children.length !== 0) {
                    let obj = {
                        text: '',
                        value: 0,
                    };
                    obj.text = res.name;
                    obj.value = res.id;
                    this.filterZone.push(obj);
                    for (let j in res.children) {
                        let objChildren = {
                            text: '',
                            value: 0,
                        };
                        objChildren.text = res.children[j].name;
                        objChildren.value = res.children[j].id;
                        this.filterZone.push(objChildren);
                    }
                }
            }
        });
    }
    CheckedKeys(zoneId) {
        this.changeParam('zoneId', zoneId);
    }
    showHandle() {
        this.popoverStatus = true;
    }
    showBtnResult(val) {
        let type = false;
        if (val === 'FACE_ATTRIBUTE' || val === 'PEDESTRIAN_ATTRIBUTE' || val === 'FACE_ALERT' || val === 'FACE_PEDESTRIAN_ALERT') {
            type = true;
        }
        return type;
    }
    handleResult(id, type) {
        const query = {
            id: String(id),
            type: this.judgeType(type),
        };
        this.$router.push({ path: '/tasklist/taskResult', query: query });
    }
    judgeType(val) {
        let type = '';
        // 人脸属性 & 人体属性 & 车辆属性
        if (val === 'FACE_ATTRIBUTE' || val === 'PEDESTRIAN_ATTRIBUTE') {
            type = 'ANALYSIS'; // 解析结果
        }
        else if (val === 'FACE_ALERT' || val === 'FACE_PEDESTRIAN_ALERT') {
            // 人脸布控 & 人脸人体布控
            type = 'ALERT'; // 告警结果
        }
        return type;
    }
    /**
     *@Description: 删除任务
     */
    handleDelete(id) {
        let confirm = `${this.$t('common.confirm')}`;
        let deviceConfirmDelete = `${this.$t('deleteMsg')}`;
        this.$elconfirm(deviceConfirmDelete, `${this.$t('common.warning')}`, {
            type: 'warning',
            cancelButtonText: `${this.$t('common.no')}`,
            confirmButtonText: confirm,
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            callback: (action) => {
                if (action === 'confirm') {
                    deleteTask(id).then((res) => {
                        this.$message({
                            message: this.$t('deletedSuccessfully'),
                            type: 'success',
                        });
                        this.refresh();
                    });
                }
            },
        });
    }
    /**
     *@Description: 编辑任务
     */
    handleEdit(id) {
        this.goPage(id, 'update');
        // this.$router.push({ path: '/tasklist/createstaffdutyleavetask', query: { 'id': String(id), type: 'edit', } });
    }
    /**
     *@Description: 查看任务详情
     */
    goView(id) {
        this.$refs[`popover-` + id].doClose();
        this.goPage(id, 'detail');
    }
    sortChange(order) {
        if (order.order === 'ascending') {
            this.changeParam('sort', 'ASC');
        }
        else {
            this.changeParam('sort', 'DESC');
        }
    }
    cellClick(row, column) {
        if (column.property === 'name') {
            this.goView(row.id);
        }
    }
    showErr(id) {
        queryDeviceTaskErrorConfigs(id).then((res) => {
            this.gridData = res;
            this.failDialogVisible = true;
        });
    }
    filterChange(e) {
        if (e.taskStatus.length > 0) {
            this.taskStatus = e.taskStatus[0];
        }
        else {
            this.taskStatus = '';
        }
        this.changeParam('taskStatus', this.taskStatus);
    }
    // 改变任务状态
    changeStatus(val) {
        const param = {
            taskId: val.id,
            taskStatus: val.status === this.disable ? this.enable : this.disable,
        };
        updateTaskStatus(param).then(() => {
            this.refresh();
        });
    }
    mounted() {
        this.initI18n();
    }
    activated() {
        this.popoverStatuss = true;
    }
    deactivated() {
        this.popoverStatuss = false;
    }
};
__decorate([
    Ref()
], default_1.prototype, "multipleTable", void 0);
__decorate([
    Prop()
], default_1.prototype, "data", void 0);
__decorate([
    Prop()
], default_1.prototype, "code", void 0);
__decorate([
    Prop()
], default_1.prototype, "loading", void 0);
__decorate([
    Prop()
], default_1.prototype, "pagination", void 0);
__decorate([
    Prop()
], default_1.prototype, "refresh", void 0);
__decorate([
    Prop()
], default_1.prototype, "goPage", void 0);
__decorate([
    Prop()
], default_1.prototype, "changeParam", void 0);
__decorate([
    Prop()
], default_1.prototype, "type", void 0);
__decorate([
    Watch('loading', { immediate: true })
], default_1.prototype, "changeLoading", null);
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "initI18n", null);
default_1 = __decorate([
    Component({
        name: 'commonTable',
        components: { authItem, tableHeader, errDialog, AuthNewitem },
        i18n: {
            messages: taskType,
        },
    })
], default_1);
export default default_1;
